import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { BannerLayout } from './BannerLayout';

const useGetAllPlansIncludedFeatures = () => {
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  return PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetAllPlansIncludedFeatures(
    p3Context,
  );
};

export const AllPlansIncludedFeaturesBanner = ({
  features,
}: {
  features?: string[];
}) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const { data, isLoading } = useGetAllPlansIncludedFeatures();

  if (isLoading && !features) {
    return null;
  }

  const items =
    features ?? data?.features?.map((item) => t(item.featureName ?? '')) ?? [];

  return (
    <BannerLayout
      title={t('premium-purchase-plan.header.all_premium_plans_include.title')}
      items={items}
    />
  );
};
